<template>
  <breadCrumbs title="Masonry Gallery" main="Gallery" title1="Masonry Gallery" />

    <div class="container-fluid">
      <div class="row">
         <masonry/>
      </div>
    </div>
</template>
<script>
import masonry from "./masonryPage.vue"
export default {
  components:{
    masonry
  },
    
};
</script>